const ROLE_LABELS: Record<string, string> = {
  actors: "بازیگر",
  directors: "کارگردان",
  director: "کارگردان",
  producer: "تهیه‌کننده",
  authors: "نویسنده",
  writer: "نویسنده",
  composer: "آهنگساز",
  makeup: "گریمور",
  "clothing-designer": "طراح لباس",
  videographer: "فیلم‌بردار",
  cinematographer: "مدیر فیلم‌برداری",
  host: "مجری",
  editor: "تدوینگر",
  "interview-guest": "مهمان",
  "voice-over-artist": "صداپیشه",
  instructor: "مدرس",
  "public-relations": "روابط عمومی",
};

export function getRoleLabel(role?: string): string {
  if (!role) return "";
  return ROLE_LABELS[role] ?? role;
}

// Roles that should be treated as "cast" (بازیگران) rather than "crew" (عوامل),
// even though they aren't the literal "actors" role.
export const CAST_LIKE_ROLES = new Set([
  "actors",
  "interview-guest",
  "voice-over-artist",
  "instructor",
]);

export function isCastLikeRole(role?: string): boolean {
  return !!role && CAST_LIKE_ROLES.has(role);
}
